import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TitleStrategy } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppComponent } from './app.component';

import { FisicoHeader } from './fisico/inc/header.component';
import { FisicoFooter } from './fisico/inc/footer.component';
import { VagasComponent } from './fisico/paginas/vagas/vagas.component';
import { VagasParceirosComponent } from './fisico/paginas/vagas-parceiros/vagas-parceiros.component';

import { HTTP_INTERCEPTORS, HttpClientModule}  from '@angular/common/http';

import { CardVagaModule } from './components/card-vaga/card-vaga.module';
import { LoaderInterceptor } from './components/loader/loader.interceptor';
import { NaoEncontradaComponent } from './juridico/paginas/nao-encontrada/nao-encontrada.component';
import { FilterPipe } from './filter.pipe';
import { CookiesComponent } from './components/cookies/cookies.component';

import { NgxMaskModule } from 'ngx-mask'

// Datapicker Angular Material
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule  } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateMaskInputDirective } from 'src/app/directives/date-mask-input.directive';
import { LocationStrategy, Location, PathLocationStrategy } from '@angular/common';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@NgModule({
    declarations: [
        AppComponent,
        FisicoHeader,
        FisicoFooter,
        NaoEncontradaComponent,
        VagasComponent,
        VagasParceirosComponent,
        FilterPipe,
        CookiesComponent,
        DateMaskInputDirective,
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        AppRoutingModule,
        FontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
        NgbModule,
        CardVagaModule,
        NgxMaskModule.forRoot(),
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        //{ provide: LocationStrategy, useClass: PathLocationStrategy } 
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
